export default __webpack_public_path__ + "static/media/backers3.94a3dc3a.png";